/**
 * FE-M3 (audit, 17.09): `schoolUpdatedAt` vine din backend ca string ISO-local
 * (`?: string`, `JwtService.java:193`). `"2024-05-02T11:00:00" < new Date(...)` forteaza AMBII
 * operanzi la numar -- `Date`-ul devine ms, string-ul devine `NaN`, orice comparatie cu `NaN` e
 * `false`. Ramura se reducea la `!schoolUpdatedAt`: reminder-ul aparea DOAR pentru profesorii a
 * caror scoala n-a fost NICIODATA actualizata, niciodata pentru populatia cu date vechi pentru
 * care a fost scrisa cerinta.
 *
 * Functie PURA, sursa unica pentru cele doua locuri care aveau aceeasi expresie gresita
 * (`AuthenticatedLayout.tsx`, `useSchoolUpdateCheck.ts`).
 */
export function trebuieReamintitaActualizareaScolii(
    role: string | undefined,
    isEnabled: boolean | undefined,
    schoolUpdatedAt: string | undefined,
    cutoffDate: Date
): boolean {
    return (
        role === 'PROFESOR' &&
        !!isEnabled &&
        (!schoolUpdatedAt || new Date(schoolUpdatedAt).getTime() < cutoffDate.getTime())
    );
}
